import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "@/widgets/admin-layout/AdminLayout";
import { ROUTES } from "@/shared/config/constants";
import { PageLoader } from "@/shared/components/PageLoader";

// Lazy load pages for code splitting
const Login = lazy(() => import("@/pages/auth/Login"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const DDCs = lazy(() => import("@/pages/admin/DDCs"));
const Users = lazy(() => import("@/pages/admin/Users"));

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route element={<AdminLayout />}>
          <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTES.DDCS} element={<DDCs />} />
          <Route path={ROUTES.USERS} element={<Users />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
